import { Button, Grid } from '@material-ui/core'
import { Field, Form, Formik } from 'formik'
import { TextField } from 'formik-material-ui'
import { isEqual } from 'lodash'
import { memo } from 'react'
import { metodoPrograma } from '../../../../components/api'

const retornaPrograma = (u = []) => ({
  idTipoUsuario: u[0],
  idContratante: u[1],
  dsTipoUsuario: u[2] || '',
  dtInclusao: u[3] || '',
  dtEclusao: u[4] || '',
})

const Edicao = ({
  linhaTipoSelecionada,
  voltar,
  linhaSelecionada,
  voltarInterno,
}) => {
  const salva = async (values) => {
    const res = await metodoPrograma('alteraTipoUsuario', values)
    if (res.status) voltarInterno()
    else alert(res.dsErro)
  }

  return (
    <Formik
      initialValues={retornaPrograma(linhaTipoSelecionada)}
      onSubmit={async (values, { setSubmitting }) => {
        await salva(values)
        setSubmitting(false)
      }}
    >
      {({ isSubmitting, submitForm }) => (
        <Form style={{ width: '100%', padding: 0 }}>
          <h4>
            {linhaSelecionada[1]} | {linhaTipoSelecionada[2]} -{' '}
            <small>Tipo de Usuário</small>
          </h4>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={2} lg={2} xl={2}>
              <Field
                component={TextField}
                name="idTipoUsuario"
                label="ID"
                disabled
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2} lg={2} xl={2}>
              <Field
                component={TextField}
                name="idContratante"
                label="ID Contratante"
                disabled
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={8} md={8} lg={8} xl={8}>
              <Field
                component={TextField}
                name="dsTipoUsuario"
                label="Nome"
                disabled={isSubmitting}
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={2} lg={2} xl={2}>
              <Field
                component={TextField}
                name="dtInclusao"
                label="Inclusão"
                disabled={true}
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2} lg={2} xl={2}>
              <Field
                component={TextField}
                name="dtExclusao"
                label="Exclusão"
                disabled={true}
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
          </Grid>

          <Grid container spacing={2}>
            <Grid
              item
              xs={12}
              style={{ display: 'flex', flexDirection: 'row-reverse' }}
            >
              <Button
                onClick={submitForm}
                disabled={isSubmitting}
                variant="contained"
                color="primary"
                style={{ margin: '5px' }}
              >
                Salvar
              </Button>
              <Button
                onClick={voltar}
                variant="contained"
                color="secondary"
                style={{ margin: '5px' }}
              >
                Cancelar
              </Button>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  )
}

export default memo(Edicao, isEqual)
